(() => {
  function quantityInput(box) {
    const area = box.closest('product-info');
    return area && area.querySelector('quantity-input input[name="quantity"]');
  }

  function sync(box) {
    const input = quantityInput(box);
    if (!input) return;
    const quantity = Number(input.value);
    box.querySelectorAll('[data-bl-quantity]').forEach((button) => {
      button.setAttribute('aria-pressed', String(quantity === Number(button.dataset.blQuantity)));
      const maximum = Number(input.getAttribute('max'));
      const minimum = Number(input.getAttribute('min')) || 1;
      const step = Number(input.getAttribute('step')) || 1;
      const target = Number(button.dataset.blQuantity);
      button.disabled = (maximum > 0 && target > maximum) || target < minimum || (target - minimum) % step !== 0;
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bl-quantity]');
    if (!button || button.disabled) return;
    const box = button.closest('[data-bl-volume]');
    const input = quantityInput(box);
    if (!input) return;
    input.value = button.dataset.blQuantity;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    sync(box);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="quantity"]')) return;
    const area = event.target.closest('product-info');
    if (area) area.querySelectorAll('[data-bl-volume]').forEach(sync);
  });

  function initialize() {
    document.querySelectorAll('[data-bl-volume]').forEach(sync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.quantityUpdate, initialize);
  }
})();
